import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CooperationInvitation} from './cooperation-invitation.model';
import {COOPERATION_INVITATIONS} from '../api-config';

@Injectable({
  providedIn: 'root'
})
export class CooperationInvitationService {

  constructor(private httpClient: HttpClient) {
  }

  getByCode(code: string): Observable<CooperationInvitation> {
    let params: HttpParams = new HttpParams();
    params = params.set('code', code);
    return this.httpClient.get<CooperationInvitation>(COOPERATION_INVITATIONS + '/', {params});
  }

  put(acceptingOfficeAllocationId: string, invId: string, code: string, status: ResponseStatus): Observable<CooperationInvitation> {
    return this.httpClient.put<CooperationInvitation>(COOPERATION_INVITATIONS + '/' + invId, {
      code,
      status,
      acceptingOfficeAllocationId
    });
  }

}

export enum ResponseStatus {
  ACCEPTED = 'ACCEPTED',
  DENIED = 'DENIED'
}
